









export default
  name: 'ManageTemplate'

  components: {
  }

  props:
    title:
      type: String
      default: ''
    message:
      type: String
      default: ''
    is_full:
      type: Boolean
      default: false
    is_middle:
      type: Boolean
      default: false

  methods: {
    submit: (e) ->
      e.preventDefault()
      e.stopPropagation()
      this.$emit('submit', e)
  }
